import React from 'react';
import { Link } from 'gatsby';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const tabs = [
  {
    key: 'physical',
    name: 'Physical Gift Cards Terms',
    href: '/terms/physical'
  },
  {
    key: 'digital',
    name: 'Digital Gift Cards Terms',
    href: '/terms/digital'
  }
]

function handleSelect(event) {
  event.preventDefault();
  const tagKey = event.target.value;

  if (typeof window !== 'undefined') {
    window.location.pathname = `/terms/${tagKey}`
  }
}

function TabBar({ tabKey }) {
  return (
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full focus:ring-gray-500 focus:border-gray-500 border-gray-300 rounded-md"
          onBlur={handleSelect}
          defaultValue={tabKey}
        >
          {tabs.map(tab => (
            <option key={tab.key} value={tab.key}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex justify-center" aria-label="Tabs">
            {tabs.map(tab => (
              <Link to={tab.href}
                key={tab.name}
                className={classNames(
                  (tab.key === tabKey)
                    ? 'border-gray-700 text-gray-700'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                  'w-1/4 py-4 px-1 text-center border-b-2 font-medium text-medium'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                {tab.name}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}

export default TabBar;
